import React = require('react');

const OVER_65_CONTACT_NUMBER = '03301 731 704';

interface IMedicalInformationControlVariantProps {
  showOver65Contact: boolean;
}

export const MedicalInformationControlVariant = ({ showOver65Contact }: IMedicalInformationControlVariantProps) => {
  return (
    <div className="medical-card">
      <div className="medical-card-right">
        <h2>Medical Declaration</h2>
        <p>
          We’ll ask you a few questions about health and medical history.
        </p>
        <p>
          This includes illnesses, injuries, or medical conditions that are diagnosed or under
          investigation - for example you're waiting for tests, results, or treatment.
        </p>
        <div className="medical-card-bottom">
          <div className="medical-card-bottom-text">
            <p>
              These questions help us make sure your cover fits your needs and protects you if
              something unexpected happens. If any information is missing or incorrect, it could
              affect a future claim.
            </p>
            {showOver65Contact && (
              <p className="medical-card-contact">
                <strong>
                  Need some help with your quote?<br />
                  Give us a call on&nbsp;<a href={`tel:${OVER_65_CONTACT_NUMBER.replace(/\s/g, '')}`}>{OVER_65_CONTACT_NUMBER}</a>
                </strong>
              </p>
            )}
          </div>
          <img className="annie-non-mobile-img" src={require('../../img/annie_thinking_left_face.png')} alt="Annie thinking"/>
          <img className="annie-mobile-img" src={require('../../img/annie_thinking_left_face_mobile.png')} alt="Annie thinking"/>
        </div>
      </div>
    </div>
  )
}
